import React from "react";
import PropTypes from "prop-types";

export default function HeroTextCarouselItem(props) {
    return (
        <div className={`text-group ${props.active ? "" : "hide"} `}>
            <h1>{props.title}</h1>
            <h2>{props.subtitle}</h2>
            { props.subtitleExtended && <p>{props.subtitleExtended}</p> }
        </div>
    );
};

HeroTextCarouselItem.propTypes = {
    active: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    subtitleExtended: PropTypes.string,
};